export default __webpack_public_path__ + "dbeb3d6ad1a0d60e4d77de49fd162e52.png";